module.exports = __webpack_public_path__ + "img/to-page.ab1b15bd.svg";